import { createAction } from 'redux-actions';
import { combineReducers } from 'redux';
import firebase from 'firebase';

// Constants
export const ALL_CHARTS_RESULT = 'charts/ALL_CHARTS_RESULT';
export const CREATE_CHART = 'charts/CREATE_CHART';
export const EDIT_CHART = 'charts/EDIT_CHART';
export const REMOVE_CHART = 'charts/REMOVE_CHART';

// Reducer
const initialState = [];

const charts = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CHARTS_RESULT:
      return action.payload;
    case CREATE_CHART:
      return [...state, action.payload];
    case EDIT_CHART:
      return state.map(chart => {
        if (chart.key === action.payload.key) {
          return action.payload;
        }
        return chart;
      });
    case REMOVE_CHART:
      return state.filter(chart => chart.key !== action.payload);
    default:
      return state;
  }
};

const syncer = (state = false, action) => {
  switch (action.type) {
    case ALL_CHARTS_RESULT:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  charts,
  syncer,
});

// Action creators
export const allChartsResult = createAction(ALL_CHARTS_RESULT);
export const createChart = createAction(CREATE_CHART);
export const editChart = createAction(EDIT_CHART);
export const removeChart = createAction(REMOVE_CHART);

export const listenToCharts = () => async (dispatch, getState) => {
  const ref = firebase.database().ref('charts');
  const snap = await ref.once('value');
  const { auth: { uid } } = getState();
  const allCharts = [];
  snap.forEach(s => {
    const chart = s.val();
    if (chart.creator.uid === uid || chart.isPublic) {
      allCharts.push({
        ...chart,
        key: s.key,
      });
    }
  });
  dispatch(allChartsResult(allCharts));
  ref.on('child_added', s => {
    const chart = s.val();
    if (chart.creator.uid === uid || chart.isPublic) {
      if (!getState().charts.charts.find(c => c.key === s.key)) {
        dispatch(createChart({ ...chart, key: s.key }));
      }
    }
  });

  ref.on('child_changed', s => {
    const chart = s.val();
    if (chart.creator.uid === uid || chart.isPublic) {
      dispatch(
        editChart({
          ...chart,
          key: s.key,
        })
      );
    }
  });

  ref.on('child_removed', s => {
    dispatch(removeChart(s.key));
  });
};



// WEBPACK FOOTER //
// ./src/modules/charts/Charts.js